import { TextContentGridStandard } from "../../../../modules/text-content-grid/components/TextContentGridStandard/TextContentGridStandard";
import type { ITextContentGridBlockProps } from "./TextContentGridBlock.props";

export const TextContentGridBlock = (props: ITextContentGridBlockProps) => {
  if (!props.items?.length) {
    return null;
  }

  return <TextContentGridStandard {...props} />;
};

TextContentGridBlock.displayName = "Block::TextContentGridBlock";
